import { useEffect } from 'react'

import { Spinner } from '@forwardflow/ui/Spinner'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AuthService from '@forwardflow/services/AuthService'

const Logout = () => {
   const [searchParams] = useSearchParams()
   const navigate = useNavigate()
   const clearSessionData = () => {
      const isTourDone = LocalStorage.get('isTourDone')
      const isCampaignTourDone = LocalStorage.get('isCampaignTourDone')

      LocalStorage.clear()

      if (isTourDone) LocalStorage.put('isTourDone', isTourDone)
      if (isCampaignTourDone)
         LocalStorage.put('isCampaignTourDone', isCampaignTourDone)
   }

   const logout = async () => {
      await AuthService.apiLogout()
      clearSessionData()
      navigate('/signin')
   }

   useEffect(() => {
      logout()
   }, [searchParams])

   return (
      <div className="h-[100vh] flexc">
         <Spinner />
      </div>
   )
}

export default Logout